import { useContext, useMemo } from 'react';
import { createStateContext, withStateContext } from '../../../common';
import { useAssemblySearchReducer } from '../reducers';
import { initialAssemblySearchState } from '../states';
import { jsx as _jsx } from "react/jsx-runtime";
var AssemblySearchContext = createStateContext(initialAssemblySearchState);
var useAssemblySearchContext = function () { return useContext(AssemblySearchContext); };
function AssemblySearchProvider(_a) {
    var children = _a.children;
    var _b = useAssemblySearchReducer(), state = _b.state, dispatch = _b.dispatch;
    var providerState = useMemo(function () { return ({ state: state, dispatch: dispatch }); }, [state, dispatch]);
    return /*#__PURE__*/ _jsx(AssemblySearchContext.Provider, { value: providerState, children: children });
}
function withAssemblySearchContext(Component) { return withStateContext(AssemblySearchProvider, Component); }
export { AssemblySearchContext, AssemblySearchProvider, useAssemblySearchContext, withAssemblySearchContext };
